export default __webpack_public_path__ + "static/media/Slide6.2cf3a8ef.JPG";